import { useCompetitionByType } from "../../redux/features/categories/selectors";
import { CompetitionData } from "../../components/ActiveCompetitions/types";
import { FEATURED_COMPETITION_BG_COLOUR, FEATURED_COMPETITION_ENDS_TEXT_COLOUR } from "./header-constants";
import { getEndsInLabel } from "../../../helpers/endsIn";

const FeaturedCompetitionsNew = () => {
  const featuredCategory = useCompetitionByType("featured");
  const onCompetitionClick = (competition: CompetitionData) => {
    if (competition.PageUrl) {
      location.href = competition.PageUrl;
    }
  };
  const scrollToFeaturedCompetitions = () => {
    if (location.pathname !== "/") {
      location.href = "/?navigateTo=featured";
      return;
    }
    const scrollToFeaturedCompetitionsEvent = new CustomEvent("scroll-to-category", {
      detail: "featured",
    });
    window.dispatchEvent(scrollToFeaturedCompetitionsEvent);
  };
  return (
    <div className="w-full min-w-0">
      <div className="text-gray-1 font-jost text-xs lg:text-sm font-medium leading-4 lg:leading-5 uppercase">
        Competitions we love
      </div>
      <div className="bg-white rounded-lg lg:rounded-2xl mt-3 lg:mt-5 overflow-hidden">
        <div
          className="relative flex items-center w-full h-12 px-5 overflow-hidden"
          style={{
            backgroundImage: "linear-gradient(95.72deg, #001D83 5.25%, #273F93 98.73%)",
          }}>
          <div className="flex items-center justify-center absolute left-[-96px] top-[-200px] w-[212px] h-[272px] pointer-events-none">
            <div className="relative w-[247px] h-[174px] rotate-[99.17deg]">
              <div className="absolute inset-[-75.7%_-53.44%]">
                <img
                  src="/assets/images/menu/featured-competitions/ellipse-1722.svg"
                  alt=""
                  className="block size-full max-w-none"
                />
              </div>
            </div>
          </div>
          <div className="relative z-[1] text-white font-jost text-base font-medium leading-5.5">
            Featured Competitions
          </div>
        </div>
        <div className="flex flex-col items-center py-5 lg:pt-5 lg:pb-6 px-3 lg:px-4">
          <div className="flex flex-col items-center gap-5 lg:gap-6 w-full mb-5">
            {featuredCategory.competitions.slice(0, 3).map(competition => (
              <div
                key={competition.CompetitionId}
                onClick={() => onCompetitionClick(competition)}
                className="flex items-center w-full gap-2.5 lg:gap-[23px] cursor-pointer">
                <div className="flex items-center gap-1 shrink-0">
                  <div
                    className={`rounded-sm ${FEATURED_COMPETITION_BG_COLOUR[competition.NavigationColour as keyof typeof FEATURED_COMPETITION_BG_COLOUR]} h-12 lg:h-14 w-1`}
                  />
                  <div className="rounded overflow-hidden shrink-0">
                    {competition.ImageUrl ? (
                      <img
                        src={competition.ImageUrl}
                        alt={competition.Title || "Featured competition"}
                        width={56}
                        height={56}
                        className="object-cover size-12 rounded lg:size-14"
                      />
                    ) : null}
                  </div>
                </div>

                <div className="flex flex-col justify-center gap-1 lg:gap-2 min-w-0 flex-1">
                  <div className="text-dark-1 font-jost text-sm lg:text-base font-medium leading-4 lg:leading-5 break-words">
                    {competition.Title} {competition.AdditionalCashText}
                  </div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <div
                      className={`font-jost text-xs font-medium leading-4 ${FEATURED_COMPETITION_ENDS_TEXT_COLOUR[competition.NavigationColour as keyof typeof FEATURED_COMPETITION_ENDS_TEXT_COLOUR]}`}>
                      Ends {getEndsInLabel(competition.EndDate)}
                    </div>
                    {competition.CompetitionTypePrefix === "DC" && (
                      <div
                        className={
                          "inline-flex items-center gap-[5px] px-1 py-0.5 bg-gradient-to-l from-[#3A3A3A] to-[#111111] rounded"
                        }>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                          <path
                            d="M1.50488 5.58357C1.50488 6.70983 1.94638 7.78996 2.73224 8.58634C3.51811 9.38272 4.58398 9.83013 5.69536 9.83013C6.80674 9.83013 7.87261 9.38272 8.65847 8.58634C9.44434 7.78996 9.88584 6.70983 9.88584 5.58357C9.88584 4.45732 9.44434 3.37719 8.65847 2.58081C7.87261 1.78442 6.80674 1.33702 5.69536 1.33702C4.58398 1.33702 3.51811 1.78442 2.73224 2.58081C1.94638 3.37719 1.50488 4.45732 1.50488 5.58357Z"
                            stroke="#E7B000"
                            strokeWidth="1.27778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9.03452 5.58345H10.6389M0.638916 5.58345H2.24331"
                            stroke="#E7B000"
                            strokeWidth="1.27778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.59375 5.58214H6.79155M5.69265 4.46853V6.69574"
                            stroke="#E7B000"
                            strokeWidth="1.27778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.73657 10.6388L5.73657 9.01291"
                            stroke="#FFC818"
                            strokeWidth="1.27778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.73657 2.26476L5.73657 0.63889"
                            stroke="#E7B000"
                            strokeWidth="1.27778"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="uppercase font-jost text-white font-medium text-[9px]">Skill game</span>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={
                    "flex items-center justify-center shrink-0 uppercase bg-[#EEEEEF] rounded-lg w-14 lg:w-20 h-8 lg:h-10 text-nav-azure font-jost text-xs lg:text-sm font-medium"
                  }>
                  Enter
                </div>
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={scrollToFeaturedCompetitions}
            className="mt-auto flex items-center text-nav-azure cursor-pointer">
            <span className="font-jost text-[13px] font-medium leading-4.5">
              VIEW ALL ({featuredCategory.competitions.length})
            </span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M8.33325 5.83334L12.4999 10L8.33325 14.1667"
                stroke="#3772FF"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCompetitionsNew;
